const state = () => ({
  promotionReqQueue: [],
})
const getters = {
  promotionReqQueue: (state) => state.promotionReqQueue,
}
const mutations = {
  addRequest(state, request) {
    state.promotionReqQueue.push(request)
  },
  removeRequest(state, request) {
    state.promotionReqQueue = state.promotionReqQueue.filter((item) => item !== request)
  },
  clearQueue(state) {
    state.promotionReqQueue = []
  },
}

const actions = {
  actAddRequest({ commit }, request) {
    commit('addRequest', request)
  },

  actRemoveRequest({ commit }, request) {
    commit('removeRequest', request)
  },

  actClearQueue({ commit }) {
    commit('clearQueue')
  },
}

export default { state, mutations, actions, getters }
